import Vue from 'vue'
import Router from 'vue-router'
import login from './login.js'//登录
import department from './department.js'//部门
import prelessons from './prelessons.js'//备课
import givelessions from './givelessions.js'//授课
import personal from './personal.js'//个人空间
import xiaoben from './xiaoben.js'//资源
import homeindex from './homeindex.js' //首页
import analysis from './analysis.js' //成绩分析学情分析
import unite from './unite.js' //组卷
import bigdata from './bigdata.js' //大屏
import wisdom from './wisdom.js' //智慧作业
Vue.use(Router)

var router = new Router({
  // mode: 'history',
  routes: [
    login,
    department,
	prelessons,
	givelessions,
	personal,
	xiaoben,
  homeindex,
  analysis,
  unite,
  bigdata,
	wisdom
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }//路由提供的页面跳转后的滚动行为
})
router.beforeEach((to, from, next) => {
  if (window._hmt) {
    if (to.path) {
      window._hmt.push(['_trackPageview', '/#' + to.fullPath])
    }
  }
  next()
})

//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
export default router



// WEBPACK FOOTER //
// ./src/router/index.js